export const collectIdsAndData = doc => ({ id: doc.id, ...doc.data() })
